
import {
  IClientOptions,
} from 'mqtt'

export const OPTIONS: IClientOptions = {
  clean: true, // true: 세션 삭제, false: 세션 유지
  connectTimeout: 10000, // MQTT 타임아웃 시간
  resubscribe: true, // 연결 끊김 후 재연결 시 기존 구독 유지
  reconnectPeriod: 10000, // 재연결 간격 시간: 10초
  keepalive: 1, // 하트비트 간격 시간: 1초
}
